<template>
  <div class="main-view">
    <el-radio-group
      v-model="table.params.status"
      class="tabsWrap"
      @change="handleTabs"
    >
      <el-radio-button :label="1">生效中({{ table.total_1 }})</el-radio-button>
      <el-radio-button :label="2">已失效({{ table.total_2 }})</el-radio-button>
    </el-radio-group>
    <div class="section shadow filter__wrap">
      <el-form
        ref="elFormDomSel"
        inline
        :model="table.params"
        :size="subUnitSize"
      >
        <el-form-item label="商品名称" prop="goods_name">
          <el-input
            size="mini"
            v-model.trim="table.params.goods_name"
            placeholder="请输入"
            clearable
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="供应商分类" prop="order_cate_id">
          <el-select
            v-model="table.params.order_cate_id"
            filterable
            placeholder="请选择"
            clearable
            @change="onSearch"
          >
            <el-option
              v-for="item in orderCateArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商名称" prop="supplier_id">
          <el-select
            v-model="table.params.supplier_id"
            filterable
            id="bind_id"
            clearable
            placeholder="请输入"
            @change="supplieridcChange"
          >
            <el-option
              v-for="item in supplierArr"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh-right" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <el-row>
        <el-button :size="subUnitSize" type="primary" @click="importUpload"
          >导入锁价</el-button
        >
        <el-button :size="subUnitSize" plain @click="addGoods"
          >添加商品</el-button
        >
        <el-button
          :size="subUnitSize"
          plain
          icon="el-icon-download"
          @click="exportData_batch('/admin/lock/export')"
          >导出</el-button
        >
      </el-row>
    </div>

    <VTable
      has-pagionation
      :field="field"
      showSelect
      :loading="table.loading"
      :data="table.data"
      :page="table.params.page"
      :pageSize="table.params.count"
      :total="table.total"
      :tree-props="{ children: 'children', hasChildren: 'has_child' }"
      :hasPagionation="true"
      :default-expand-all="true"
      :showIndex="true"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:lock_start_end="{ row }">
        {{ row.lock_start + "至" + row.lock_end }}
      </template>
      <template v-slot:action="{ row }">
        <el-button type="text" class="editBtn" @click="viewDetail(row)"
          >查看</el-button
        >
        <el-button type="text" class="editBtn" @click="editRow(row)"
          >编辑</el-button
        >
        <el-button
          type="text"
          class="delBtn"
          v-if="is_sys"
          @click="deleteRow(row)"
          >删除</el-button
        >
      </template>
    </VTable>
    <addLockGoods
      :supplierArr="supplierArr"
      ref="addLockGoodsRef"
      @confirm="getTable"
    ></addLockGoods>
    <importLock
      :supplierArr="supplierArr"
      :exapleExcel="exapleExcel"
      ref="importLockRef"
      @confirm="getTable"
    ></importLock>
    <detail ref="detailRef" @refresh="getTable"></detail>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import addLockGoods from "./components/addLockGoods.vue";
import importLock from "./components/importLock.vue";
import detail from "./components/detail.vue";
export default {
  components: {
    VTable,
    addLockGoods,
    importLock,
    detail,
  },
  mixins: [mixinTable],
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      field: [
        { name: "name", label: "供应商名称", hidden: false },
        {
          name: "city_name",
          label: "所在地区",
          showTooltip: true,
          hidden: false,
        },
        {
          name: "order_cate_name",
          label: "供货类别",
          hidden: false,
        },
        {
          name: "goods_count",
          label: "锁价商品项数",
          hidden: false,
        },
        { name: "lock_start_end", label: "锁价期限", hidden: false },
        { name: "lock_time", label: "更新时间", hidden: false },
        { name: "create_name", label: "创建人", hidden: false },
        {
          name: "action",
          label: "操作",
          fixed: "right",
          hidden: false,
          width: "160",
        },
      ],
      table: {
        loading: false,
        params: {
          status: 1,
          goods_name: "",
          supplier_id: "",
          supplier_name: "",
          order_cate_id: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
        total_1: 0,
        total_2: 0,
      },
      //
      orderCateArr: [],
      supplierArr: [], // 供应商/采购员
      exapleExcel: "",
    };
  },
  created() {
    this.getTable();
    this.getOrderCateSel();
    this.getSupplierSelStatus();
  },
  methods: {
    supplieridcChange(val) {
      if (val) {
        let obj = this.supplierArr.find((item) => item.id == val);
        this.table.params.supplier_name = obj.name;
      } else {
        this.table.params.supplier_name = "";
      }
      this.onSearch();
    },
    addGoods() {
      let dom = this.$refs.addLockGoodsRef;
      dom.toggle(true);
    },
    editRow(row) {
      let dom = this.$refs.addLockGoodsRef;
      dom.toggle(true);
      dom.getDetail(row);
    },
    deleteRow(row) {
      this.$confirm(`请确认删除操作`, `提示`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.$http.post("/admin/lock/delete", { id: row.id }).then((res) => {
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: `删除成功`,
            });
            this.getTable();
          }
        });
      });
    },
    viewDetail(row) {
      let dom = this.$refs.detailRef;
      dom.toggle(true);
      dom.getDetail(row,this.table.params.goods_name);
    },
    // 重置查询条件
    reset() {
      this.$refs.elFormDomSel.resetFields();
      this.table.params.supplier_name = '';
      this.table.params.page = 1;
      this.table.params.count = 10;
      this.getTable();
    },
    importUpload() {
      let dom = this.$refs.importLockRef;
      dom.toggle(true);
    },
    getTable() {
      let _params = { ...this.table.params };
      this.table.loading = true;
      this.$http.get("/admin/lock/list", { params: _params }).then((res) => {
        if (res.code === 1) {
          this.table.loading = false;
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.exapleExcel = res.data.file;
          this.table.total_1 = res.data.total_1;
          this.table.total_2 = res.data.total_2;
        }
      });
    },
    exportData_batch(url) {
      if (this.multipleSelection.length) {
        this.plexportData(url);
      } else {
        this.exportData(url);
      }
    },
  },
};
</script>
